import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const organizationsService = {
  getData,
  getDataById,
  deleteDataById,
  update,
  add,
  searchExperian,
  createDataByBin,
  createAddress,
  updateAddress,
  addContact,
  updateWithPath
}

function getData ({
  q = '',
  limit = '999999999',
  ordering = '',
  offset = 0,
  expands = ''
}) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}&expand=${expands}&organizations_addresses__property_status=active`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function createDataByBin (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/create_experian/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function getDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/${id}/?expand=addresses,addresses.state,addresses.organizations_addresses,contacts,contacts.organizations_contacts,bids,created_by,modified_by`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function updateWithPath (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/${id}/`
  return fetch(url, requestOptions.patch(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function searchExperian (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organizations/search_experian/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function createAddress (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-addresses/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function updateAddress (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-addresses/${id}`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}

function addContact (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-contacts/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(organizations => {
      return organizations
    })
}



// WEBPACK FOOTER //
// ./src/services/organizations.service.js